export var PortalUserRole;
(function (PortalUserRole) {
    PortalUserRole["Admin"] = "ADMIN";
    PortalUserRole["GroupAdmin"] = "GROUP_ADMIN";
    PortalUserRole["Accounting"] = "ACCOUNTING";
    PortalUserRole["CustomerService"] = "CUSTOMER_SERVICE";
})(PortalUserRole || (PortalUserRole = {}));
//# sourceMappingURL=PortalUserRole.js.map